import { useEffect } from 'react'

/**
 * Run a callback when the user presses Escape.
 *
 * Used by modals/overlays so the standard "press Esc to dismiss" behavior
 * works without each component re-implementing the listener.
 *
 * @param {() => void} onEscape - handler to fire on Escape key press
 * @param {boolean} active - when false, the listener is detached (default true)
 */
export default function useEscapeKey(onEscape, active = true) {
  useEffect(() => {
    if (!active || typeof onEscape !== 'function') return undefined

    const handler = (event) => {
      if (event.key === 'Escape' || event.key === 'Esc') {
        onEscape(event)
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [onEscape, active])
}
